module.exports = __webpack_public_path__ + "static/media/profilebtnview.5987a213.svg";